export enum TableActionsTypes {
    Edit = 'EDIT',
    CustomEdit = 'CUSTOM_EDIT',
    EditWithRedux = 'EDIT_WITH_REDUX',
    Delete = 'DELETE',
    DeleteWithAction = 'DELETE_WITH_ACTION',
    CustomDelete = 'CUSTOM_DELETE',
    Approve = 'APPROVE',
    Duplicate = 'DUPLICATE',
    Deactivate = 'DEACTIVATE',
    Default = 'DEFAULT',
    Manage = 'MANAGE',
    ManageLaptop = 'MANAGE_LAPTOP',
    ManageTablet = 'MANAGE_TABLET',
    DefaultActionWithProgressBar = 'DEFAULT_ACTION_WITH_PROGRESS_BAR',
    ViewResult = 'VIEW_RESULT',
    TabTableEdit = 'TAB_TABLE_EDIT',
    Impersonate = 'IMPERSONATE',
    ToggleEnabled = 'TOGGLE_ENABLED',
    ChangeStatus = 'CHANGE_STATUS',
}
